import { render, staticRenderFns } from "./PersonalDataFormStep.vue?vue&type=template&id=07e86479&scoped=true&"
import script from "./PersonalDataFormStep.vue?vue&type=script&lang=js&"
export * from "./PersonalDataFormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e86479",
  null
  
)

export default component.exports